import {Injectable} from '@angular/core';
import {MxGridCustomizerEvent} from './mx-grid-customizer-event';

export interface GridGrandTotalsService {

    readonly isGrandTotalsDefined: boolean;

     /**
      * column.prop to value
      */
    readonly grandTotals: ReadonlyMap<string, number | string>;

    setGrandTotals(grandTotals: ReadonlyMap<string, number | string>): void;
}

@Injectable()
export class MxGridGrandTotalsService implements GridGrandTotalsService {

    get isGrandTotalsDefined(): boolean {
        return this._grandTotals.size > 0;
    }

    private _grandTotals: ReadonlyMap<string, number | string> = new Map();

    get grandTotals(): ReadonlyMap<string, number | string> {
        return this._grandTotals;
    }

    setGrandTotals(grandTotals: ReadonlyMap<string, number | string>): void {
        this._grandTotals = grandTotals;
    }

    constructor() {
    }

    public setUp(event: MxGridCustomizerEvent) {
        if (event.grandTotals) {
            this._grandTotals = event.grandTotals;
        }
    }

}

